import {
  GET_COMPONENT_USAGE_FULLFILLED,
  GET_COMPONENT_USAGE_REJECTED,
  CLEAR_COMPONENT_USAGE
} from './const';

export const defaultState = {};

/**
 * Reducer for component usage
 * @param {object} state - state object for canvas
 * @param {object} action - dispatched action object
 * @returns {object} new state.object after dispatched performing action
 */
export const componentUsageReducer = function componentUsageReducer(
  state = defaultState,
  action = {}
) {
  switch (action.type) {
    case CLEAR_COMPONENT_USAGE:
      return {
        ...state,
        data: null,
        error: undefined
      };
    case GET_COMPONENT_USAGE_REJECTED:
      console.warn(`Get component usage request failed with error: ${action.error}`);
      return {
        ...state,
        error: action.error.message
      };
    case GET_COMPONENT_USAGE_FULLFILLED:
      return {
        ...state,
        data: action.payload,
        error: undefined
      };
    default:
      return state;
  }
};
